function readEnvBase() {
  try {
    if (typeof process !== 'undefined' && process && process.env) {
      return process.env.VUE_APP_API_BASE_URL || process.env.VUE_APP_API_BASE || '';
    }
  } catch (e) {}
  return '';
}

function detectDefault() {
  // In production builds, fall back to same-origin (relative URLs).
  // Only use an explicit domain when VUE_APP_API_BASE_URL is set.
  try {
    if (typeof process !== 'undefined' && process && process.env && process.env.NODE_ENV === 'development') {
      return 'http://localhost:8080';
    }
  } catch (e) {}
  return '';
}

export const API_BASE_URL = readEnvBase() || detectDefault();

export function withApiBase(url) {
  if (!url) return API_BASE_URL;
  if (/^https?:\/\//i.test(url)) return url;
  if (!API_BASE_URL) return url;
  if (url.startsWith('/')) return `${API_BASE_URL}${url}`;
  return `${API_BASE_URL}/${url}`;
}
